
  import {Component, PropSync, Vue} from 'vue-property-decorator';
  import sbSelectToyDialog from '@/components/stead/workspaces/stepbuilder/dialogboxes/sbSelectToyDialog.vue';
  import {TObjectDocument} from '@/models/tobject.model';
  import SbSelectToolDialog from '@/components/stead/workspaces/stepbuilder/dialogboxes/sbSelectToolDialog.vue';
  import SbSelectRushDialog from "@/components/stead/workspaces/stepbuilder/dialogboxes/sbSelectRushDialog.vue";
  import {StepDocumentFlat} from "@/models/testcase.model";

  @Component({
    components: {SbSelectRushDialog, SbSelectToolDialog, SbSelectToyDialog: sbSelectToyDialog}
  })
  export default class SbInsertionDialog extends Vue {
    // Les props
    @PropSync('show', {default: false}) private isVisible!: boolean

    // Les propriétés
    // Les propriétés calculées
    // Les hooks
    // Les méthodes surveillées
    // Les méthodes d'instance
    private onSelectedTObject(tobj: TObjectDocument) {
      // console.log('InsertionDialog tobj', tobj)
      this.$emit('tobject', tobj)
      this.isVisible = false
    }

    private onInsertRushSteps(steps: StepDocumentFlat[]) {
      this.$emit('steps', steps)
      this.isVisible = false
    }

    // Les méthodes statiques
  }
